import { render } from "./InventoryDailyTrendChart.vue?vue&type=template&id=352b1b38&scoped=true"
import script from "./InventoryDailyTrendChart.vue?vue&type=script&lang=js"
export * from "./InventoryDailyTrendChart.vue?vue&type=script&lang=js"

import "./InventoryDailyTrendChart.vue?vue&type=style&index=0&id=352b1b38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352b1b38"]])

export default __exports__